// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"49611430","703":"fd16acea","763":"9f2d73c1"}[chunkId] + ".chunk.css";
};